import {
  IconBuildingSkyscraper,
  IconCode,
  IconCloud,
} from "@tabler/icons-react"

import { EventCategory } from "@costory/types/prisma-client"

export const IconsEventsCategory = ({
  category,
  size = 20,
}: {
  category: EventCategory
  size?: number
}) => {
  if (category === EventCategory.BUSINESS) {
    return <IconBuildingSkyscraper size={size} />
  }
  if (category === EventCategory.TECHNICAL) {
    return <IconCode size={size} />
  }
  if (category === EventCategory.PROVIDER) {
    return <IconCloud size={size} />
  }
}
